import http from "../../http-common";

const loadCorrDates = async(corridor) => {
    const response = await http.get(`/corridorDates/${corridor}`).then((response) => {
        return response
    })

    let corrList = await response.data.dates
    return corrList
}


export default loadCorrDates;
